import _slicedToArray from "/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import prepareEngine from './engines';
import { getPrefixedEntry } from './attr.js';

var getAffix = function getAffix(source, affix) {
  return typeof affix === 'function' ? affix(source) : affix || '';
};

export default function bibliography(data) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$template = options.template,
      template = _options$template === void 0 ? 'apa' : _options$template,
      _options$lang = options.lang,
      lang = _options$lang === void 0 ? 'en-US' : _options$lang,
      _options$format = options.format,
      format = _options$format === void 0 ? 'text' : _options$format,
      _options$nosort = options.nosort,
      nosort = _options$nosort === void 0 ? false : _options$nosort;
  var citeproc = prepareEngine(data, template, lang, format);
  var sortedIds = citeproc.updateItems(data.map(function (entry) {
    return entry.id;
  }), nosort);

  if (options.append || options.prepend) {
    var append = options.append,
        prepend = options.prepend;
    var items = data.reduce(function (items, entry) {
      items[entry.id] = entry;
      return items;
    }, {});

    citeproc.sys.wrapBibliographyEntry = function (id) {
      var entry = items[id];
      return [getAffix(entry, prepend), getAffix(entry, append)];
    };
  } else {
    citeproc.sys.wrapBibliographyEntry = function () {
      return ['', ''];
    };
  }

  var bibliography = citeproc.makeBibliography();

  var _bibliography = _slicedToArray(bibliography, 2),
      _bibliography$ = _bibliography[0],
      bibstart = _bibliography$.bibstart,
      bibend = _bibliography$.bibend,
      bibBody = _bibliography[1];

  var entries = bibBody.map(function (element, index) {
    return getPrefixedEntry(element, sortedIds[index]);
  });
  return bibstart + entries.join('') + bibend;
}